import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import EditableHTML from '@v4/components/common/EditableHTML'
import { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import { useEditableLabel } from './EditableLabel.hooks'

const EditableLabel = props => {
	const [{ className, classes, shadow, value, editable }, { handleChange }] = useEditableLabel(props)

	return (
		<EditableHTML
			className={clsx(className, classes.root, 'q-scale-title')}
			html={value}
			component="div"
			variant="subtitle2"
			displayEmpty
			editable={editable}
			shadow={shadow}
			placeholder="Write your label here"
			editorVariant={EDITOR_VARIANT.SHORT}
			editorValidElements="br,i/em,b/strong,u,span[style],a[*]"
			onChange={handleChange}
		/>
	)
}

EditableLabel.propTypes = {
	className: PropTypes.string,
	index: PropTypes.number.isRequired,
	value: PropTypes.string,
	shadow: PropTypes.bool,
	onChange: PropTypes.func,
}

EditableLabel.defaultProps = {
	onChange: () => {},
}

export default memo(EditableLabel)
